import Alpine from 'alpinejs';
import { initializeCountdowns } from './modules/countdown.js';
import marquee from './modules/marquee.js';
import Logger from './modules/logger.js';

// Global
window.Alpine = Alpine;
window.Logger = Logger;

// Register Alpine components
Alpine.data('marquee', marquee);

// Inits
Alpine.start();
initializeCountdowns();